var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "general-wrap" },
    [
      _vm._m(0),
      _c(
        "el-container",
        { staticClass: "general" },
        [
          _c(
            "el-main",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingTpl,
                  expression: "loadingTpl"
                }
              ],
              staticClass: "main"
            },
            [
              _c("tpl-editor", {
                ref: "tplEditor",
                attrs: {
                  "insert-html": _vm.innerString,
                  "change-placeholder": _vm.valChange,
                  "del-placeholder": _vm.delInner,
                  "select-placeholder": _vm.currentOpVar.varName || ""
                },
                on: {
                  editorReadyCallback: _vm.handleEditorReadyCallback,
                  change: _vm.handleChange,
                  doubleclickPlaceholder: _vm.handeDoubleclickPlaceholder,
                  clickPlaceholder: _vm.handleClickPlaceholder
                }
              })
            ],
            1
          ),
          _c(
            "el-aside",
            { staticClass: "aside", attrs: { width: "260px" } },
            [
              _c("h4", [_vm._v("模板信息")]),
              _c(
                "el-form",
                {
                  ref: "tplFrm",
                  staticClass: "tpl-info",
                  attrs: {
                    model: _vm.tplFrm,
                    rules: _vm.tplFrmRules,
                    size: "small"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "模板名称", prop: "tplName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "模板名称", maxlength: "30" },
                        model: {
                          value: _vm.tplFrm.tplName,
                          callback: function($$v) {
                            _vm.$set(_vm.tplFrm, "tplName", $$v)
                          },
                          expression: "tplFrm.tplName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { type: "danger" },
                          on: {
                            click: function($event) {
                              return _vm.tplFrmSubmit()
                            }
                          }
                        },
                        [_vm._v("保存模板")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          on: {
                            click: function($event) {
                              return _vm.toShowEditTplVarDialog(false)
                            }
                          }
                        },
                        [_vm._v("添加变量")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "draggable",
                    {
                      attrs: { list: _vm.tplVarList },
                      on: {
                        start: function($event) {
                          _vm.dragging = true
                        },
                        end: function($event) {
                          _vm.dragging = false
                        }
                      }
                    },
                    [
                      _vm._l(_vm.tplVarList, function(item, i) {
                        return _vm.tplVarList.length
                          ? [
                              _c("div", { key: i, staticClass: "val-item" }, [
                                _c(
                                  "p",
                                  {
                                    key: i,
                                    class:
                                      _vm.currentOpVar.varName == item.varName
                                        ? "active"
                                        : "",
                                    on: {
                                      click: function($event) {
                                        return _vm.selectCurrentOpVar(
                                          item.varName
                                        )
                                      },
                                      dblclick: function($event) {
                                        return _vm.toShowEditTplVarDialog(true)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.varName) +
                                        "\n                "
                                    ),
                                    _c("i", {
                                      staticClass: "el-icon-circle-close del",
                                      on: {
                                        click: function($event) {
                                          return _vm.delTplVar(item)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ])
                            ]
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.editTplVarDialogName,
                visible: _vm.showEditTplVarDialog,
                width: "25%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.showEditTplVarDialog = $event
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "tplVarFrm",
                  staticClass: "val-form",
                  attrs: {
                    model: _vm.tplVarFrm,
                    rules: _vm.tplVarFrmRules,
                    size: "small"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "变量名称", prop: "varName" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.tplVarFrm.varName,
                          callback: function($$v) {
                            _vm.$set(_vm.tplVarFrm, "varName", $$v)
                          },
                          expression: "tplVarFrm.varName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "变量类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "select",
                          model: {
                            value: _vm.tplVarFrm.varType,
                            callback: function($$v) {
                              _vm.$set(_vm.tplVarFrm, "varType", $$v)
                            },
                            expression: "tplVarFrm.varType"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "文本", value: 0 }
                          }),
                          _c("el-option", {
                            attrs: { label: "数字", value: 1 }
                          }),
                          _c("el-option", {
                            attrs: { label: "日期", value: 2 }
                          }),
                          _c("el-option", {
                            attrs: { label: "手机号码", value: 3 }
                          }),
                          _c("el-option", {
                            attrs: { label: "身份证号码", value: 4 }
                          }),
                          _c("el-option", {
                            attrs: { label: "营业执照号", value: 5 }
                          }),
                          _c("el-option", {
                            attrs: { label: "统一社会编码格式", value: 6 }
                          }),
                          _c("el-option", {
                            attrs: { label: "电子邮箱", value: 7 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-checkbox", {
                        attrs: { label: "是否必填" },
                        model: {
                          value: _vm.tplVarFrm.varIsMust,
                          callback: function($$v) {
                            _vm.$set(_vm.tplVarFrm, "varIsMust", $$v)
                          },
                          expression: "tplVarFrm.varIsMust"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          attrs: { type: "danger" },
                          on: { click: _vm.editTplVarSubmit }
                        },
                        [_vm._v("确认添加")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn",
                          on: {
                            click: function($event) {
                              _vm.showEditTplVarDialog = false
                            }
                          }
                        },
                        [_vm._v("取消")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h1",
      {
        staticClass: "com-title com-ht",
        staticStyle: { "margin-bottom": "20px" }
      },
      [
        _c("i"),
        _vm._v("设置新增模板"),
        _c("span", { staticClass: "ms" }, [
          _vm._v("/ 设置合同固定条款，智能生成合同信息")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-724a0672", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-724a0672","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/tpl/add/general.vue
// module id = iBRC
// module chunks = 89